/** Delay between typing and a tournament search request (list search and header search server matches). */
export const SEARCH_DEBOUNCE_MS = 200;

/** Page size of the header search tab index and of its server matches. */
export const SEARCH_INDEX_PAGE_SIZE = 50;
